import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["prefSelect", "countrySelectArea"];

  connect() {
    this.updateCountryVisibility();
  }

  updateCountryVisibility() {
    if (this.prefSelectTarget.value == 90) {
      this.countrySelectAreaTarget.classList.remove("is-hide");
    } else {
      this.countrySelectAreaTarget.classList.add("is-hide");
    }
  }
}
